import { useMemo } from "react";
import dayjs from "dayjs";
import { useTranslation } from "@coworker/locales";
import Summary from "../Summary/Summary";
import { DatePicker } from "@coworker/apprestructured/src/shared/components/DatePicker/DatePicker";
import {
  futureTaskInScheduleSummaryText,
  futureTaskSummaryText,
} from "../../helper";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";
import { Schedule } from "@coworker/apprestructured/src/task-management/types/Schedule";

type FutureTaskProps = {
  start: string | null;
  startDateError: string | null;
  // Existing schedule
  schedule?: Schedule;
  onStartChange: (start: string | null) => void;
};

export const FutureTask = (props: FutureTaskProps) => {
  const { t } = useTranslation();

  const today = useMemo(() => dayjs().format("YYYY-MM-DD"), []);

  return (
    <ModalColumn gap="medium">
      <FixaText textStyle="Heading.S">{t("scheduleTaskString")}</FixaText>
      <DatePicker
        label={t("scheduledForString")}
        value={props.start}
        onChange={(value) => props.onStartChange(value)}
        errorMessage={props.startDateError}
        min={today}
      />
      {props.start && (
        <Summary>
          {props.schedule
            ? futureTaskInScheduleSummaryText(props.start, props.schedule, t)
            : futureTaskSummaryText(props.start, t)}
        </Summary>
      )}
    </ModalColumn>
  );
};
